
import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import ArrowIcon from "../../shared/arrow";
import { TAB_STATUS } from "../post-inspection-diy-documentation-tab/constant";

const STATUS_MAPPING = {
    [TAB_STATUS.VERIFIED]: "styles.verified",
    [TAB_STATUS.FAILED]: "styles.failed",
    [TAB_STATUS.PENDING]: "styles.notStarted",
    [TAB_STATUS.UNDER_VERIFICATION]: "styles.notStarted",
    [TAB_STATUS.PICKUP_SCHEDULED]: "styles.verified",
    [TAB_STATUS.PICKUP_CANCELLED]: "styles.failed",
    [TAB_STATUS.SLOT_UNAVAILABLE]: "styles.unavailable",
    [TAB_STATUS.ACTION_REQUIRED]: "styles.failed",
    [TAB_STATUS.SLOT_EXPIRED]: "styles.failed"
};

const PostInspectionDiyTabCard = ({
    name,
    children,
    title,
    subTitle,
    status,
    onClick
}) => {

    const handleClick = () => {
        onClick(name);
    };

    const getStyles = () => {
        return STATUS_MAPPING[status] || "";
    };

    return (
        <div styleName={"styles.postInspectionDiyTabCard"} onClick={() => {handleClick();}}>
            <div styleName={"styles.cardText"}>
                {children && children}
                <div>
                    <h3>{title}</h3>
                    <h4>{subTitle}</h4>
                    {status && <span styleName={getStyles()}>{status}</span> }
                </div>
            </div>
            <ArrowIcon blue={"BlueArrow"} rotateBy={-90} />
        </div>
    );
};

PostInspectionDiyTabCard.propTypes = {
    name: PropTypes.string,
    children: PropTypes.any,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    status: PropTypes.string,
    onClick: PropTypes.func
};

export default PostInspectionDiyTabCard;
